/**
 * Компонент многострочного текстового поля с поддержкой label, error сообщений и testId
 * Дата: 28.12.2025 - Создан для TODO-013 (Templates Page)
 */
import { forwardRef, TextareaHTMLAttributes } from 'react';
import { cn } from '@/utils/cn';

interface TextareaProps extends TextareaHTMLAttributes<HTMLTextAreaElement> {
  label?: string;
  error?: string;
  testId?: string;
}

export const Textarea = forwardRef<HTMLTextAreaElement, TextareaProps>(
  ({ label, error, testId, className, ...props }, ref) => {
    return (
      <div>
        {label && (
          <label className="block text-sm font-medium text-shell-text mb-1.5">
            {label}
          </label>
        )}
        <textarea
          ref={ref}
          data-testid={testId}
          className={cn(
            'shell-textarea',
            error && 'border-shell-danger focus:!border-shell-danger',
            className
          )}
          {...props}
        />
        {error && (
          <span className="text-shell-danger text-sm mt-1 block">{error}</span>
        )}
      </div>
    );
  }
);

Textarea.displayName = 'Textarea';

